export default {
  FORM: 'FORM',
  CORRECTION: 'CORRECTION'
};
